import moment from 'moment';
import {UsaStates} from 'usa-states';

const stateList = new UsaStates().states.map(s=>{
	return {label: s.name, value: s.name};
});
stateList.push({label: 'Other', value: 'Other'});

const required = true;

const formConfig =  {
	replacements: {
		partnerFirstNameDisplay: {
			key: 'partnerFirstNameDisplay',
			default: 'Your Partner',
			isPossessive: true
		},
		clientFirstNameDisplay: {
			key: 'firstName',
			default: 'Your',
			isPossessive: false
		}
	},
	signUpConfirmation: {
		code: {
			key: 'confirmationCode',
			type: 'Text',
			label: 'Confirmation Code',
			required
		}
	},
	artist: {
		name: {
			type: 'Text',
			label: 'Band/Artist Name',
			required
		},
		status: {
			type: 'Switch',
			label: 'Status'
		},
		hfmPicksOptIn: {
			type: 'Checkbox',
			label: 'Opt in to HFM Picks',
			tooltipText: 'What is HFM Picks?',
			tooltipContent: 'HFM Picks is a special monthly playlist curated by the HFM staff where we create a five-song playlist comprised of music from multiple artists (one-track-per-artist max each month). Opting-in to HFM Picks allows fans to listen, download and keep any and all full-length songs featured. It also allows us to use your music for HiFiveRadio, an HFM-curated, streaming-only playlist.  This feature gives you multiple ways to capture new fans and gain more subscriptions!'
		},
		genre: {
			type: 'Select',
			label: 'Genre',
			options: [
				{
					label: 'Select Genre',
					value: 0,
				}
			],
			injectOptions: {
				options: [
					{
						listKey: 'sortedGenreList',
						collection: 'genres',
						labelProp: 'label',
						valueProp: '_id'
					}
				]
			},
			required
		},
		// paymentServiceID: {
		// 	type: 'Text',
		// 	label: 'Stripe Email Address',
		// 	validators: ['email'],
		// 	required
		// }
	},
	user: {
		firstName: {
			type: 'Text',
			label: 'First Name',
			required
		},
		lastName: {
			type: 'Text',
			label: 'Last Name',
			required
		},
		dob: {
			type: 'MaskedInput',
			mask:"99\/99\/9999",
			placeholder: 'MM/DD/YYYY',
			label: 'Birthdate (MM/DD/YYYY)',
			// setFilter: (value) => value ? moment(value).format('MMDDYYYY') : null,
			validators: ['date', 'isOfAge'],
			required
		},
		userName: {
			type: 'Text',
			label: 'Email',
			required
		},
		password: {
			type: 'Password',
			label: 'Password',
			validators: ['password'],
			required
		},
		confirmPassword: {
			type: 'Password',
			label: 'Confirm Password',
			validators: ['password'],
			required
		},
		email: {
			type: 'Text',
			label: 'Email Address',
			validators: ['email'],
			required
		},
		phoneNumber: {
			type: 'Text',
			placeholder: '1 (###) ###-####',
			label: 'Phone Number (U.S. or International)',
			// validators: ['phone']
		},
		gender: {
			required,
			type: 'Select',
			label: 'Gender',
			options: [
				{
					label: 'Male',
					value: 'MALE'
				},
				{
					label: 'Female',
					value: 'FEMALE'
				},
				{
					label: 'Non-Binary',
					value: 'NON-BINARY'
				}
			],
		},
		location: {
			type: 'Select',
			label: 'Your Location',
			options: stateList
		},
		cardName: {
			type: 'Text',
			label: 'Name on Card',
			placeholder: 'Name on Card'
		},
		postalCode: {
			type: 'Text',
			label: 'Postal Code',
			placeholder: '#####(-####)',
		}
	},
	song: {
		artistID: {
			type: 'Hidden',
			valueKey: 'artist.id'
		},
		albumIDs: {
			type: 'Select',
			label: 'Album',
			multi: true,
			options: [
				{
					label: 'Singles',
					value: 'singles'
				}
			],
			injectOptions: {
				options: [
					{
						collection: 'albums',
						labelProp: 'name',
						valueProp: '_id'
					}
				]
			}
		},
		title: {
			type: 'Text',
			label: 'Title',
			required
		},
		embedCode: {
			type: 'TextArea',
			label: 'Embed Code'
		},
		explicit: {
			type: 'Checkbox',
			label: 'Explicit?'
		},
		additionalArtists: {
			type: 'Text',
			label: 'Additional Artists'
		},
		publisher: {
			type: 'Text',
			label: 'Publisher'
		},
		songWriters: {
			type: 'Text',
			label: 'Songwriter(s)'
		},
		ISRC: {
			type: 'Text',
			label: 'ISRC'
		},
		releaseDate: {
			type: 'Text',
			placeholder: 'MM/DD/YYYY',
			label: 'Release Date (MM/DD/YYYY)',
			setFilter: (value) => value ? moment(value).format('MM/DD/YYYY') : null,
			validators: ['date'],
			required
		},
	},
	album: {
		artistID: {
			type: 'Hidden',
			valueKey: 'artist.id'
		},
		artwork: {
			type: 'Hidden'
		},
		name: {
			type: 'Text',
			label: 'Name'
		},
		linerNotes: {
			type: 'TextArea',
			label: 'Liner Notes'
		}
	},
	genre: {
		id: {
			type: 'Hidden',
			valueKey: 'genre.id'
		},
		label: {
			type: 'Text',
			label: 'Label'
		}
	},
	document: {
		_id: {
			type: 'Hidden',
			valueKey: 'document._id'
		},
		// type: {
		// 	type: 'Hidden',
		// 	valueKey: 'document.type'
		// },
		label: {
			type: 'Text',
			label: 'Label'
		},
		content: {
			type: 'Text',
			label: 'Content'
		}
	},
	playlist: {
		_id: {
			type: 'Hidden',
			valueKey: 'playlist._id'
		},
		title: {
			type: 'Text',
			label: 'Title',
			valueKey: 'playlist.title',
			default: 'Untitled',
			required
		},
		listType: {
			type: 'Text',
			// type: 'Hidden',
			label: 'List Type',
			valueKey: 'playlist.listType',
			default: 'playlist.listType'
		},
		genre: {
			type: 'Text',
			// type: 'Hidden',
			label: 'Genre',
			valueKey: 'playlist.genre',
			default: 'playlist.genre'
		},
		// showOnFrontPage: {
		// 	type: 'Checkbox',
		// 	label: 'Show on Front Page?'
		// 	// valueKey: 'playlist.showOnFrontPage'
		// },
		isHFMPicks: { // LEGACY
			type: 'Checkbox',
			label: 'Is HFM Pick?'
		},
		isHFMRadio: { // LEGACY
			type: 'Checkbox',
			label: 'Is HFM Radio?'
		},
		HFMPicksPosition: {
			type: 'Text',
			label: 'HFM Pick Position'
		}
	}
};


export default formConfig;
